import React, { Component } from 'react';

import AnalysisBookmarklet from 'bookmarklets/analysis-document.bookmarklet';
import AnalysisDocumentsList from './components/AnalysisDocumentsList.component';
import Can from '../../Can';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';

class AnalysisDocumentsBrowserComponent extends Component {
    constructor(props) {
        super(props);

        this.onNewDocument = this.onNewDocument.bind(this);
        this.onDocumentDelete = this.onDocumentDelete.bind(this);
    }

    componentDidMount() {}

    onDocumentDelete(url) {
        const { analysis, saveAnalysis } = this.props;

        // attempt to find document in existing docs
        analysis.documents = analysis.documents.filter(value => {
            return value.url !== url;
        });

        saveAnalysis(analysis).catch(error => {
            Swal('Oops...', error, 'error');
        });
    }

    onNewDocument(event) {
        event && event.preventDefault();
        const { analysis, saveAnalysis, newDocument = {} } = this.props;
        const { title = '', url = '', description = '' } = newDocument || {};

        Swal({
            title: 'New Analysis Document',
            showCloseButton: false,
            showCancelButton: true,
            focusConfirm: false,
            html: `
                <div>
                    <div class="form-group">
                    <label for="swal-name">Name</label>
                    <input id="swal-name" class="form-control swal2-input" value="${title}">
                    <label for="swal-description">Description</label>
                    <input id="swal-description" class="form-control swal2-input" value="${description}">
                    <label for="swal-url">URL</label>
                    <input id="swal-url" class="form-control swal2-input" value="${url}">
                </div>
            `,
            confirmButtonText: 'Save',
            cancelButtonText: 'Cancel',
            preConfirm: function () {
                const result = {
                    name: document.getElementById('swal-name').value,
                    description: document.getElementById('swal-description').value,
                    url: document.getElementById('swal-url').value,
                };

                // validate input
                let validationMessage;
                const urlExpression =
                    /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
                if (!result.name || result.name.length === 0) {
                    validationMessage = 'Document name is required';
                } else if (
                    !result.url ||
                    result.url.length === 0 ||
                    !result.url.match(urlExpression)
                ) {
                    validationMessage = 'A valid document URL is required';
                } else if (
                    // check document urls in analysis are unique
                    analysis.documents &&
                    analysis.documents.length &&
                    analysis.documents.find(doc => {
                        // simple test for now
                        return doc.url === result.url;
                    })
                ) {
                    validationMessage = 'Each document URL must be unique';
                }

                if (validationMessage) {
                    Swal.showValidationMessage(validationMessage);
                } else {
                    return new Promise(function (resolve) {
                        resolve({
                            name: document.getElementById('swal-name').value,
                            description: document.getElementById('swal-description').value,
                            url: document.getElementById('swal-url').value,
                        });
                    });
                }
            },
        }).then(result => {
            if (!result.dismiss) {
                analysis.documents.push({
                    name: result.value.name,
                    description: result.value.description,
                    url: result.value.url,
                });

                saveAnalysis(analysis).catch(error => {
                    Swal('Oops...', error, 'error');
                });
            }
        });
        return false;
    }

    // TODO: extract documents from analysis, component shouldn't depend on the parent wrapping object
    render() {
        const { analysis, newDocument } = this.props;

        const isAdminLocked = analysis.adminLocked ? analysis.adminLocked : false;

        return (
            <div className="card">
                <div className="card-header d-flex justify-content-between">
                    <div>Analysis Documents</div>
                    {isAdminLocked ? (
                        <div>
                            <small className="text-muted">
                                <i>Modification Lockout</i>
                            </small>
                        </div>
                    ) : (
                        <Can I="update" a="Analysis">
                            <a
                                className="btn btn-link p-0"
                                onClick={this.onNewDocument}
                                href={`javascript:${encodeURIComponent(
                                    `(function(url){${AnalysisBookmarklet}})('${document.location.origin}');`
                                )}`}
                                title="Add Analysis Document"
                            >
                                Add Analysis Document
                            </a>
                            {newDocument && this.onNewDocument()}
                        </Can>
                    )}
                </div>
                <div className="card-body p-1">
                    <AnalysisDocumentsList
                        documents={analysis.documents}
                        onDocumentDelete={this.onDocumentDelete}
                        isAdminLocked={isAdminLocked}
                    />
                </div>
            </div>
        );
    }
}

AnalysisDocumentsBrowserComponent.propTypes = {
    analysis: PropTypes.object.isRequired,
    newDocument: PropTypes.object,
    saveAnalysis: PropTypes.func.isRequired,
};

export default AnalysisDocumentsBrowserComponent;
